import * as Api from '@ViewModels';
import { useMutation } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';

export const useCancelTextCampaignMutation = ({
	onError,
	onSuccess,
}: {
	onSuccess?: (data: Api.ISystemJob) => void;
	onError?: (error: Api.IOperationResultNoValue) => void;
} = {}) => {
	const userSession = useUserSession();
	return useMutation({
		mutationFn: ({ bulkAutomationId }: { bulkAutomationId: string }) => {
			return userSession.webServiceHelper.callAsync<Api.ISystemJob>(
				Api.ImpersonationBroker.composeApiUrl({ urlPath: `bulkautomation/${bulkAutomationId}` }),
				'DELETE'
			);
		},
		onError,
		onSuccess,
	});
};
